import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="disclosure"
//
// ボタンクリックで領域を開閉する汎用 disclosure（アコーディオン式トグル）。
// button の aria-expanded を状態として保持し、content の hidden を切り替える。
// HTML:
//   <div data-controller="disclosure">
//     <button data-disclosure-target="button" data-action="click->disclosure#toggle" aria-expanded="false">...</button>
//     <div data-disclosure-target="content" hidden>...</div>
//   </div>
export default class extends Controller {
  static targets = ['button', 'content']

  toggle() {
    const expanded = this.buttonTarget.getAttribute('aria-expanded') === 'true'
    this.buttonTarget.setAttribute('aria-expanded', String(!expanded))
    this.contentTarget.hidden = expanded
  }
}
